export default __webpack_public_path__ + "static/media/argon-react.32156a42.png";